import { yupResolver } from "@hookform/resolvers/yup"
import { useState } from "react"
import * as yup from "yup"

import DialogProvider from "@components/dialog_provider"
import TextInput from "@components/text_input"
import { UsersData, useCustomerPageContext } from "@contexts/customer"
import { updateCustomerProducts } from "@domain/customer/infos"
import useControlledForm from "@hooks/use_controlled_form"
import { Stack } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query"
import { showErrorToast } from "@utils/toast"

export type UpdateAccountBalanceForm = {
  amount: number
}

export default function UpdateAccountBalance({
  isOpen,
  setClose
}: {
  isOpen: boolean
  selectedRow?: UsersData
  setClose: () => void
}) {
  const { translate, currentCustomer: customer } = useCustomerPageContext()

  const queryClient = useQueryClient()

  const schema = yup
    .object({
      amount: yup
        .number()
        .required(translate("amount_field_is_required"))
        .min(0)
    })
    .required()

  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid, isDirty }
  } = useControlledForm<UpdateAccountBalanceForm>({
    resolver: yupResolver(schema),
    mode: "all",
    defaultValues: {
      // amount: Number(customer?.package?.accountBalance?.toFixed(2)) || 0
      amount: 0
    }
  })

  // useEffect(() => {
  //   if (selectedRow) {
  //     reset({
  //       paymentMethod: selectedRow.paymentMethod as string,
  //       amount: selectedRow.amount as string
  //     })
  //   }
  // }, [selectedRow])

  const [loading, setLoading] = useState(false)

  function handleClose() {
    if (loading) {
      return
    }
    setClose()
    reset({ amount: 0 })
  }

  async function onSubmit(data: UpdateAccountBalanceForm) {
    if (!customer?.package?._id) {
      return
    }

    const newAccountBalance = data.amount
    setLoading(true)
    const { isSuccess, errorMessage } = await updateCustomerProducts({
      _id: customer?.package?._id,
      accountBalance: newAccountBalance
    })
    if (!isSuccess && !!errorMessage) {
      showErrorToast(errorMessage)
      setLoading(false)
      return
    }
    setLoading(false)
    queryClient.invalidateQueries({ queryKey: ["customer-data-table"] })
    handleClose()
  }
  return (
    <DialogProvider
      title={translate("add_account_balance")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: setClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("save"),
        color: "primary",
        onClick: handleSubmit(onSubmit),
        loading: loading,
        disabled: !isValid || !isDirty
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack gap={1}>
        <TextInput<UpdateAccountBalanceForm>
          type="number"
          label={translate("amount")}
          disabled={loading}
          name="amount"
          placeholder="0"
          control={control}
        />
      </Stack>
    </DialogProvider>
  )
}
